module.exports = __webpack_public_path__ + "static/Gatsby-logo-20b51d3f4767a3b56adce27a3fa3d6ee.png";